import React from "react";

import CustomAutoCompleteFilter from "../lib/components/customdatagridfilter/CustomFilter";
import { FormatterNumber, FormatterNumber2Decimals, TextFormatter } from "../lib/components/Formatters";
import { handleColumnsArrangement, handleColumnsWidth } from "../lib/helpers/grid";
import Tooltip from "@material-ui/core/Tooltip";
import WarningIcon from "@material-ui/icons/Warning";

const cellWidthTiny = 50;
const cellWidthSmall = 90;
const cellWidthMedium = 120;

const defaultColumnProperties = {
  resizable: true,
  sortable: true,
  filterable: true,
};

let currentSpace = true;

export const ErrorCellFormatter = ({ row }) => {
  const isError = row.edicomparisonerror || "";

  if (isError !== "") {
    return (
      <Tooltip title={isError}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <WarningIcon style={{ color: isError.includes("Missing") ? "white" : "red", fontSize: 18 }} />
        </div>
      </Tooltip>
    );
  }

  return <div></div>;
};

export const GridColumnsComparison = (data, filters, arrangement, columnsWidth, section: string) => {
  let postValueInfo = "";

  if (data) {
    if (currentSpace) {
      postValueInfo = " ";
    }
    currentSpace = !currentSpace;
  }

  const columns = [
    {
      key: "edicomparisonerror",
      name: "#" + postValueInfo,
      width: cellWidthTiny,
      formatter: ErrorCellFormatter,
      filterRenderer: (e) => <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"edicomparisonerror"} data={data} section={section} />,
    },
    {
      key: "Barcode",
      name: "Barcode" + postValueInfo,
      width: cellWidthMedium + 40,
      formatter: TextFormatter,
      filterRenderer: (e) => <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Barcode"} data={data} section={section} />,
    },
    {
      key: "Sequence Number",
      name: "Seq" + postValueInfo,
      width: cellWidthTiny,
      formatter: FormatterNumber,
      filterRenderer: (e) => <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Sequence Number"} data={data} section={section} />,
    },
    {
      key: "Location Code",
      name: "Location" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Location Code"} data={data} section={section} />,
    },
    {
      key: "Farm Number",
      name: "Farm" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Farm Number"} data={data} section={section} />,
    },
    {
      key: "Commodity Code",
      name: "Commodity" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Commodity Code"} data={data} section={section} />,
    },
    {
      key: "Variety Code",
      name: "Variety" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Variety Code"} data={data} section={section} />,
    },
    {
      key: "Pack Code",
      name: "Pack" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Pack Code"} data={data} section={section} />,
    },
    {
      key: "Mark Code",
      name: "Mark" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Mark Code"} data={data} section={section} />,
    },
    {
      key: "Grade Code",
      name: "Grade" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Grade Code"} data={data} section={section} />,
    },
    {
      key: "Count Code",
      name: "Count" + postValueInfo,
      width: cellWidthSmall,
      formatter: TextFormatter,
      filterRenderer: (e) => <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Count Code"} data={data} section={section} />,
    },
    {
      key: "No Cartons",
      name: "Cartons" + postValueInfo,
      width: cellWidthSmall,
      formatter: FormatterNumber,
      filterRenderer: (e) => <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"No Cartons"} data={data} section={section} />,
    },
    {
      key: "Pallet Size",
      name: "Pallet Size" + postValueInfo,
      width: cellWidthSmall,
      formatter: FormatterNumber2Decimals,
      filterRenderer: (e) => <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Pallet Size"} data={data} section={section} />,
    },
    {
      key: "Orig Intake Waybill",
      name: "Waybill" + postValueInfo,
      width: cellWidthMedium,
      formatter: TextFormatter,
      filterRenderer: (e) => <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Orig Intake Waybill"} data={data} section={section} />,
    },
  ].map((c) => ({ ...c, ...defaultColumnProperties }));

  return handleColumnsWidth(handleColumnsArrangement([], arrangement, columns), columnsWidth, columns);
};

export const GridColumnsSystem = (data, filters, arrangement, columnsWidth) => GridColumnsComparison(data, filters, arrangement, columnsWidth, "stockchecksystem");

export const GridColumnsFile = (data, filters, arrangement, columnsWidth) => GridColumnsComparison(data, filters, arrangement, columnsWidth, "stockcheckfile");
